{
  "profileMenu": {
    "ariaLabel": "Ouvre menu profil",
    "signOut": "Se d&eacute;connecter",
    "errorMessage": "D&eacute;sol&eacute;, nous n'avons pas pu charger vos informations personnalis&eacute;es dans la <i>Bridge Bar</i>.<br><br>Vous n'&ecirc;tes pas connect&eacute;, votre session est expir&eacute;e ou votre navigateur bloque peut-&ecirc;tre les cookies de tiers.",
    "loadingMessage": "Nous essayons de charger vos informations d'utilisateur.<br /><br />Merci de votre patience."
  },
  "applicationSwitcher": {
    "header": "Solutions Cox Automotive"
  },
  "orgContextSelector": {
    "onboardingPrompt": "Choisissez votre concessionnaire pour commencer",
    "noMemberships": "Aucune concession attribuée",
    "loadError": "Chargement des concessionnaires impossible",
    "searchPlaceholder": "Rechercher des concessionnaires",
    "searchPrompt": "Recherchez un concessionnaire pour commencer",
    "searchMinLength": "Continuez à écrire pour rechercher",
    "searchMaxLength": "La recherche est trop longue; raccourcissez-la",
    "searchLoading": "Recherche en cours…",
    "searchNoResults": "Aucun concessionnaire ne correspond à votre recherche",
    "searchError": "Recherche de concessionnaires impossible",
    "searchRetry": "Réessayez"
  },
  "sideNav": {
    "ariaLabel": "Ouvrir le menu de navigation latérale",
    "menuLabel": "Menu",
    "dashboardLabel": "Tableaux de bord",
    "productUpdatesLabel": "Mises à jour des produits",
    "railAriaLabel": "Navigation latérale",
    "chevronShowMore": "Afficher plus d'éléments de navigation",
    "chevronBackToTop": "Retour en haut",
    "menuTitle": "Menu",
    "menuClose": "Fermer le menu"
  }
}
